import styled from 'styled-components'

interface ButtonContainerProps {
  color?: string
  fontSize?: string
}

export const Container = styled.p<ButtonContainerProps>`
  color: ${(props) =>
    props.color ? props.color : props.theme.color.neutral.white};
  background-color: inherit;
  height: 100%;
  width: 100%;
  min-height: 1.5rem;
  min-width: 6.5rem;
  cursor: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  text-wrap: nowrap;

  font-size: ${(props) =>
    props.fontSize ? props.fontSize : props.theme.font.textsm};
`
